import service from './../utils/server'
const modName = '/common/h5/select/';
/**
 * 用户类型
 * @param data
 */
export const userType = data => {
    return service({
        url: modName + 'userType',
        method: 'post',
        data
    })
};

//不包含承运商的用户类型
export const nonCarrierUserType = data => {
  return service({
    url: modName + 'nonCarrierUserType',
    method: 'post',
    data
  })
};

/**
 * 角色
 */
export const selectRole = data => {
  return service({
    url: modName + 'roleInfo',
    method: 'post',
    data
  })
};

/**
 * 获取部门
 * @param data
 * @returns {AxiosPromise}
 */
export const getDeptList = data => {
  return service({
    url: modName + 'deptList',
    method: 'post',
    data
  })
};

/**
 * 园区名称
 * @param data
 * @returns {AxiosPromise}
 */
export const getPark = data => {
  return service({
    url: modName + 'getPark',
    method: 'post',
    data
  })
};

/**
 * 访问事由
 * @param data
 * @returns {AxiosPromise}
 */
export const getVisitSubject = data => {
  return service({
    url: modName + 'getVisitSubject',
    method: 'post',
    data
  })
};













// WEBPACK FOOTER //
// ./src/api/selects.js